import { render, staticRenderFns } from "./WebhookRow.vue?vue&type=template&id=2d4c8ec6&scoped=true&"
import script from "./WebhookRow.vue?vue&type=script&lang=js&"
export * from "./WebhookRow.vue?vue&type=script&lang=js&"
import style0 from "./WebhookRow.vue?vue&type=style&index=0&id=2d4c8ec6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4c8ec6",
  null
  
)

export default component.exports